import React from "react"

export const TimeWheelHour = ({ hourClass, hourInfo }) => (
  <div className={`hour-el hour-el--${hourClass}`}>
    <span className="hour-el__hour">{hourInfo[0]}</span>
    <span className="hour-el__day-period">{hourInfo[1]}</span>
  </div>
)
